import {useCallback} from 'react'

import useCvip from './useCvip'
import {useWallet} from 'use-wallet'
import {provider} from 'web3-core'
import {
  approve,
  getCvipContract,
  getXCvipStakingContract
} from '../cvip/utils'

const useApproveStaking = () => {
  const {account}: { account: string; ethereum: provider } = useWallet()
  const cvip = useCvip()
  const lpContract = getCvipContract(cvip)
  const contract = getXCvipStakingContract(cvip)

  const handleApprove = useCallback(async () => {
    try {
      const tx = await approve(lpContract, contract, account)
      return tx
    } catch (e) {
      return false
    }
  }, [account, lpContract, contract])

  return {onApprove: handleApprove}
}

export default useApproveStaking
